import React, {useState} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Chip, Grid, Paper, Typography} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { iEIL } from "../../types/iEIL";
import AlunoTabDiscDisc from "./AlunoTabDiscDisc";
import AlunoTabDiscDee from "./AlunoTabDiscDee";
import {useSelector} from "react-redux";
import {RootState} from "../../store/reducers";
import AlunoAddDOffSelector from "./AlunoAddDOffSelector";
import AlunoEnrollment from "./AlunoEnrollment";
import { sharedStyles } from "./alunoDialogStyles";

const sxStyles = {
    mainGrid: {},
    summary: sharedStyles.accordionSummary,
    summaryMainGrid: sharedStyles.containerRow,
}

interface iEILDialog  {
    registro?: iEIL,
    open: boolean
}

const AlunoTabEnrollEIL = ({ registro, open  } : iEILDialog ) => {

    const [expanded, setExpanded ] = useState( open );
    const aluno = useSelector( (state : RootState) => state.cadastros.aluno );

    let eilId: number = 0;
    if (registro?.id) { eilId = registro.id; }

    const handleExpand = () => {
        setExpanded(!expanded)
    }

    // Coleta todos os modulos unicos do nivel (para alinhar colunas) e IDs para detectar orfaos
    const levelModuleIds = new Set<number>();
    const allModuleDescriptions: string[] = [];
    if (registro?.level?.discipline) {
        registro.level.discipline.forEach((d: any) => {
            d.disciplineModule?.forEach((dm: any) => {
                levelModuleIds.add(dm.id);
                if (dm.Description && !allModuleDescriptions.includes(dm.Description)) {
                    allModuleDescriptions.push(dm.Description);
                }
            });
        });
    }
    allModuleDescriptions.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    const orphanDees: any[] = [];
    if (registro?.enrollment) {
        registro.enrollment.forEach((e: any) => {
            e.disciplineEntree?.forEach((dee: any) => {
                if (!levelModuleIds.has(dee.disciplineOffer?.DisciplineModule_id)) {
                    orphanDees.push(dee);
                }
            });
        });
    }

    return (<React.Fragment>
        <Grid   sx={{...sxStyles.mainGrid, margin: 0, m:0, p:0}}>
            <Accordion
                expanded={expanded}
                onChange={handleExpand}
                sx={{...sxStyles.mainGrid, margin: 0, m:0, p:0}}
            >
                <AccordionSummary sx={{...sxStyles.summary, margin: 0, m:0, p:0}}  expandIcon={<ExpandMoreIcon />}>
                    <Grid item container sx={{...sxStyles.summaryMainGrid}} sm={12} md={12} lg={2} xl={2} >
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>{registro?.level?.Description ?? ''}</Typography>
                        <Chip label={`EIL #${registro?.id ?? ''}`} size="small" variant="outlined" sx={{ ml: 1 }} />
                    </Grid>
                    <Grid item container sx={{...sxStyles.summaryMainGrid,  justifyContent: 'flex-start'}} sm={12} md={12} lg={10} xl={10} >
                        { registro?.enrollment?.map( (e: any, eix: number) => {
                             return (
                                <Grid item container key={eix} sx={{...sxStyles.summaryMainGrid, m:2}} sm={12} md={12} lg={3} xl={3} >
                                    <AlunoEnrollment registro={e} eilId={eilId} ixeId={eix}  eId={e.id} aluno={aluno} />
                                </Grid>
                                    )
                        } )}
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item container sm={12} md={12} lg={12} xl={12} >
                        <AlunoAddDOffSelector levelId={registro?.level.id } />
                    </Grid>

                    {   registro?.level?.discipline?.map( ( d: any, ix: number) => {
                            return ( <AlunoTabDiscDisc key={ix} registro={d} eilId={eilId} allModules={allModuleDescriptions} />  )
                        })
                    }

                    {orphanDees.length > 0 && (
                        <Paper variant="outlined" sx={{ mt: '10px', borderRadius: '10px', backgroundColor: 'warning.light', borderColor: 'warning.main', p: '5px', width: '100%' }}>
                            <Grid container>
                                <Grid item sm={12}>
                                    <Typography variant="subtitle2" color="warning.dark">Disciplinas de outros niveis</Typography>
                                </Grid>
                                <Grid item container sm={12}>
                                    {orphanDees.map((dee: any, ix: number) => (
                                        <Grid key={dee.id ?? ix} item sm={4} md={4} lg={4} xl={4} sx={{ padding: '2px' }}>
                                            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                                                {dee.disciplineOffer?.disciplineModule?.discipline?.Description ?? dee.disciplineOffer?.discipline?.Description ?? ''} - {dee.disciplineOffer?.disciplineModule?.Description ?? ''}
                                            </Typography>
                                            <Typography variant="caption" display="block" color="text.secondary">
                                                Disc: {dee.disciplineOffer?.Discipline_id} | Mod: {dee.disciplineOffer?.DisciplineModule_id} | Parecer: {dee.disciplineOffer?.classOffer?.id} | Level: {dee.disciplineOffer?.classOffer?.Level_id}
                                            </Typography>
                                            <AlunoTabDiscDee registro={dee} eilId={eilId} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Paper>
                    )}
                </AccordionDetails>

            </Accordion>
        </Grid>
    </React.Fragment>);
}
export default (AlunoTabEnrollEIL);
